/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Picker_Remove_AdultInputs */

const en_guest_picker_remove_adult = /** @type {(inputs: Guest_Picker_Remove_AdultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove adult`)
};

/**
* | output |
* | --- |
* | "Remove adult" |
*
* @param {Guest_Picker_Remove_AdultInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guest_picker_remove_adult = /** @type {((inputs?: Guest_Picker_Remove_AdultInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Picker_Remove_AdultInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guest_picker_remove_adult(inputs)
});